(function() {
  'use strict';

  function OrganisationsController(Profile, Organisations, OrganisationSearch,
                                    List, Security, $translate, Utils) {
    var ctrl = this;

    ctrl.$onInit = function() {
      ctrl.options = {
        stateField: 'state',
        trackBy: 'id',
        actionButtons: function(item) {
          return [
            {
              label: $translate.instant('Edit settings'),
              icon: 'icon-edit',
              route: '/organisations/settings/' + item.id,
              showCondition: function() {
                if (!item.local) {
                  return false;
                }
                return Security.hasPermission('organisations.edit');
              },
              klass: 'text-info'
            }
          ];
        }
      };

      Utils.setPageTitle('Organisations');

      ctrl.searchModel = Profile.getListPreferences('organisations').current;

      ctrl.list = new List({
        search: OrganisationSearch.search,
        model: ctrl.searchModel,
        idField: 'id'
      });

      Organisations.findAllWithCluster()
        .then(function(data) {
          if (data.length > 0) {
            ctrl.list.doLoadItems(data);
          }
        })
        .catch(function(err) {
          console.log(err);
        });

      ctrl.actions = [
        {
          label: $translate.instant('Control panel'),
          icon: 'icon-edit',
          route: '/organisations/control',
          showCondition: Security.hasPermission.bind(this, 'organisations.edit'),
          klass: 'btn-info'
        },
        {
          label: $translate.instant('New organisation'),
          icon: 'icon-edit',
          route: '/organisations/new',
          showCondition: Security.hasPermission.bind(this, 'organisations.edit'),
          klass: 'btn-success'
        }
      ];
    };
  }

  OrganisationsController.$inject = [
    'ProfileService',
    'OrganisationsService',
    'OrganisationSearch',
    'ListFactory',
    'SecurityService',
    '$translate',
    'UtilsService'
  ];

  angular.module('component.organisations')
    .component('organisationsList', {
      templateUrl: 'app/components/organisations/list.html',
      controller: OrganisationsController,
      controllerAs: 'orgsCtrl'
    });
})();
